import { render, staticRenderFns } from "./DemoList.vue?vue&type=template&id=4bdd8223&scoped=true&lang=pug"
import script from "./DemoList.vue?vue&type=script&lang=js"
export * from "./DemoList.vue?vue&type=script&lang=js"
import style0 from "./DemoList.vue?vue&type=style&index=0&id=4bdd8223&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdd8223",
  null
  
)

export default component.exports